import { render, staticRenderFns } from "./subscriptionStatistics.vue?vue&type=template&id=fc064afc&scoped=true"
import script from "./subscriptionStatistics.vue?vue&type=script&lang=js"
export * from "./subscriptionStatistics.vue?vue&type=script&lang=js"
import style0 from "./subscriptionStatistics.vue?vue&type=style&index=0&id=fc064afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc064afc",
  null
  
)

export default component.exports